import {useSignInContext} from "../context/SignInContextProvider";
import {Text} from "@gs-ux-uitoolkit-react/text";
import {Radio} from "@gs-ux-uitoolkit-react/radio";
import React, {useCallback, useState} from "react";
import {Button} from "@gs-ux-uitoolkit-react/button";
import {MfaMethod} from "../../../types";
import {LoadingIcon} from "@gs-ux-uitoolkit-react/loading";
import {FormControl} from '@gs-ux-uitoolkit-react/form';

export function MfaMethodSelector() {

    const {signInAttempt, setMfaMethod} = useSignInContext();
    const mfaMethods = signInAttempt?.mfaMethods || [];
    const [mfaMethod, setMfaMethod1] = useState<MfaMethod>();
    const [busy, setBusy] = useState(false);

    const handleContinue = useCallback(async () => {
        if (!mfaMethod)
            return;
        try {
            setBusy(true);
            await setMfaMethod(mfaMethod);
        } finally {
            setBusy(false);
        }
    }, [mfaMethod, setMfaMethod])

    return (
        <div className="flex flex-col items-stretch gap-6 w-full">
            <div className="flex flex-col gap-2">
                <Text typography="textTitle02" data-qa-comp="mfa-method-title">Choose a verification method</Text>
                <Text typography="textBody02Regular">Check your 'Spam' or 'Unknown Senders' folder if the SMS code does not arrive shortly.</Text>
            </div>
            <FormControl className="w-full">
                {mfaMethods.map((method, idx) => (
                    <div key={idx} className="flex flex-col gap-6 w-full">
                        {(method.maskedDayPhoneNumber || method.maskedEveningPhoneNumber) && (
                            <div className="flex flex-col gap-3">
                                <Text typography="textBody01Medium" color="colorTextNeutralBold">Text</Text>
                                <div className="flex flex-col gap-2 pl-2">
                                    {method.maskedDayPhoneNumber && (
                                        <Radio name="mfaradio" size="md" onClick={() => { method.type = "daySms"; setMfaMethod1(method); }}>
                                            {method.maskedDayPhoneNumber}
                                        </Radio>
                                    )}
                                    {method.maskedEveningPhoneNumber && (
                                        <Radio name="mfaradio" size="md" onClick={() => { method.type = "eveningSms"; setMfaMethod1(method); }}>
                                            {method.maskedEveningPhoneNumber}
                                        </Radio>
                                    )}
                                </div>
                            </div>
                        )}
                        {(method.maskedDayPhoneNumber || method.maskedEveningPhoneNumber) && (
                            <div className="flex flex-col gap-3">
                                <Text typography="textBody01Medium" color="colorTextNeutralBold">Call</Text>
                                <div className="flex flex-col gap-2 pl-2">
                                    {method.maskedDayPhoneNumber && (
                                        <Radio name="mfaradio" size="md" onClick={() => { method.type = "dayCall"; setMfaMethod1(method); }}>
                                            {method.maskedDayPhoneNumber}
                                        </Radio>
                                    )}
                                    {method.maskedEveningPhoneNumber && (
                                        <Radio name="mfaradio" size="md" onClick={() => { method.type = "eveningCall"; setMfaMethod1(method); }}>
                                            {method.maskedEveningPhoneNumber}
                                        </Radio>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                ))}
            </FormControl>

            <Button
                className="w-full"
                size="md"
                appearance="highlight"
                emphasis="bold"
                type="submit"
                onClick={handleContinue}
                disabled={!mfaMethod || busy}
                data-qa-comp="continue-button"
            >
                {!busy ? 'Continue' : <LoadingIcon size="sm"/>}
            </Button>
        </div>
    )
}